export var FocusArea;
(function (FocusArea) {
    FocusArea[FocusArea["FRONT"] = 0] = "FRONT";
    FocusArea[FocusArea["BACK"] = 1] = "BACK";
    FocusArea[FocusArea["RIGHT"] = 2] = "RIGHT";
    FocusArea[FocusArea["LEFT"] = 3] = "LEFT";
    FocusArea[FocusArea["UNDEFINED"] = 4] = "UNDEFINED";
})(FocusArea || (FocusArea = {}));
const RegionToFocus = new Map();
RegionToFocus.set('back neck label', FocusArea.FRONT);
RegionToFocus.set('chest', FocusArea.FRONT);
RegionToFocus.set('wl chest', FocusArea.FRONT);
RegionToFocus.set('wl front left', FocusArea.FRONT);
RegionToFocus.set('wl front right', FocusArea.FRONT);
RegionToFocus.set('wl front', FocusArea.FRONT);
RegionToFocus.set('wl hip', FocusArea.FRONT);
RegionToFocus.set('wr chest', FocusArea.FRONT);
RegionToFocus.set('wr front', FocusArea.FRONT);
RegionToFocus.set('wr hip', FocusArea.FRONT);
RegionToFocus.set('back', FocusArea.BACK);
RegionToFocus.set('nape', FocusArea.BACK);
RegionToFocus.set('wl back leg', FocusArea.BACK);
RegionToFocus.set('wl back', FocusArea.BACK);
RegionToFocus.set('wr back left', FocusArea.BACK);
RegionToFocus.set('wr back leg', FocusArea.BACK);
RegionToFocus.set('wr back right', FocusArea.BACK);
RegionToFocus.set('wr back', FocusArea.BACK);
RegionToFocus.set('left', FocusArea.LEFT);
RegionToFocus.set('wl side', FocusArea.LEFT);
RegionToFocus.set('wl sleeve', FocusArea.LEFT);
RegionToFocus.set('right', FocusArea.RIGHT);
RegionToFocus.set('wr side', FocusArea.RIGHT);
RegionToFocus.set('wr sleeve', FocusArea.RIGHT);
function buildIdToNameMap(styleRegions) {
    return styleRegions.reduce((map, r) => {
        map.set(r.id, r.name.toLowerCase());
        return map;
    }, new Map());
}
/**
 * Find focus area based on occupied logo regions.
 * @param styleRegions - Style regions.
 * @param logos - Mockup logos.
 */
export function findFocusAreaFromLogos(styleRegions, logos) {
    const idToName = buildIdToNameMap(styleRegions);
    let focus = FocusArea.UNDEFINED;
    for (const l of logos) {
        const name = idToName.get(l.region);
        if (name && RegionToFocus.has(name)) {
            focus = Math.min(RegionToFocus.get(name), focus);
        }
    }
    return focus;
}
/**
 * Filter focus areas based on occupied logo regions.
 * @param styleRegions - Style regions.
 * @param logos - Mockup logos.
 */
export function filterFocusAreasFromLogos(styleRegions, logos) {
    const idToName = buildIdToNameMap(styleRegions);
    const decorated = new Set();
    for (const l of logos) {
        const name = idToName.get(l.region);
        if (name && RegionToFocus.has(name)) {
            decorated.add(RegionToFocus.get(name));
        }
    }
    return [FocusArea.FRONT, FocusArea.BACK, FocusArea.RIGHT, FocusArea.LEFT].filter(area => decorated.has(area));
}
